module.exports = __webpack_public_path__ + "img/logo.33d76ba7.png";